import React, { useState } from "react";
import { API } from "./Config";
import logo from "./assets/logo.png";
import { clearStaffSession } from "./staffApi";

export default function StaffLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const login = async (event) => {
    event.preventDefault();
    if (busy) return;

    setError("");
    setBusy(true);

    try {
      const response = await fetch(`${API}/staff/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim(), password })
      });

      const data = await response.json();

      if (!response.ok) {
        if (
          response.status === 409 &&
          data.code === "STAFF_ACTIVE_SESSION_EXISTS"
        ) {
          setError(
            "This staff account is already signed in on another device. " +
            "Please sign out there before signing in here."
          );
        } else {
          setError(data.error || "Staff login failed.");
        }
        return;
      }

      if (!data.token) {
        setError("Invalid login response.");
        return;
      }

      clearStaffSession();
      localStorage.setItem("mukbiStaffToken", data.token);
      localStorage.setItem("mukbiStaffName", data.name || email.trim());

      window.location.assign("/staff");
    } catch {
      setError("Unable to connect. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  const field = {
    boxSizing: "border-box",
    width: "100%",
    padding: 12,
    marginTop: 8,
    marginBottom: 16,
    border: "1px solid #d1d5db",
    borderRadius: 8
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "#f5f7fb",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 20
    }}>
      <div style={{
        width: "100%",
        maxWidth: 420,
        background: "white",
        padding: 32,
        borderRadius: 14,
        boxShadow: "0 8px 30px rgba(0,0,0,0.08)"
      }}>
        <div style={{ textAlign: "center" }}>
          <img src={logo} alt="MUKBI" style={{ height: 52 }} />
          <h2>Staff Login</h2>
          <p style={{ color: "#64748b" }}>
            Sign in to your assigned CRM workspace.
          </p>
        </div>

        <form onSubmit={login}>
          <label htmlFor="staff-email">Email</label>
          <input
            id="staff-email"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoComplete="username"
            required
            style={field}
          />

          <label htmlFor="staff-login-password">Password</label>
          <input
            id="staff-login-password"
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
            required
            style={field}
          />

          {error && (
            <p role="alert" style={{ color: "#b91c1c" }}>{error}</p>
          )}

          <button
            type="submit"
            disabled={busy}
            style={{
              ...field,
              background: "#2c3e50",
              color: "white",
              cursor: busy ? "wait" : "pointer"
            }}
          >
            {busy ? "Signing in..." : "Sign In"}
          </button>
        </form>

        <p style={{ textAlign: "center", fontSize: 13 }}>
          CRM owner? <a href="/">Owner Login</a>
        </p>
      </div>
    </div>
  );
}
